import { Button } from '@mui/material'
import type React from 'react'
import { type ReactNode, useEffect, useRef, useState } from 'react'
import { useAuth } from '../hooks/useAuth'

type ImportButtonProps = {
  children: ReactNode
  title: string
  onImport: (selectedFile: File) => void
}

export const ImportButton: React.FC<ImportButtonProps> = props => {
  const { onImport } = props
  const [selectedFile, setSelectedFile] = useState<File | null>(null)
  const auth = useAuth()
  const fileInputRef = useRef<HTMLInputElement>(null)
  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0]
    if (file) {
      setSelectedFile(file)
    }
  }

  const onClickHandler = async () => {
    // ファイル選択
    fileInputRef.current?.click()
    // 同じファイル選択のため、初期化
    if (fileInputRef.current) {
      fileInputRef.current.value = ''
    }
  }
  useEffect(() => {
    if (selectedFile) {
      onImport(selectedFile)
      setSelectedFile(null)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedFile])

  return (
    <>
      <input
        type="file"
        ref={fileInputRef}
        style={{ display: 'none' }}
        accept=".zip"
        onChange={handleFileChange}
      />
      <Button
        disabled={auth.isDisable}
        onClick={onClickHandler}
        sx={{
          justifyContent: 'center',
          alignContent: 'center',
          color: '#FFFFFF',
          font: 'normal normal bold 21px/32px Noto Sans JP',
          backgroundColor: auth.isDisable ? '#CACACA' : '#282828',
          '&:hover': {
            backgroundColor: '#282828',
            opacity: 0.8,
          },
          boxShadow: '0px 2px 2px #00000014',
          height: '54px',
          width: '189px',
          borderRadius: '40px',
          mt: '10px',
        }}
      >
        {props.children}
      </Button>
    </>
  )
}
